/*
 * Public API Surface of core
 */
export default {};
